export default {
    BASE_URL: '/pub/image',
    api: [
        {
            name: 'list',
            desc: '图片列表',
            method: 'GET',
            path: 'list',
            mock: true
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/pub/image.js